import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "tile is-ancestor" }
const _hoisted_3 = { class: "tile is-parent is-vertical" }
const _hoisted_4 = { class: "tile is-child" }
const _hoisted_5 = { class: "card has-table has-mobile-sort-spaced block" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("header", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, " Perfil de entidad ")
], -1)
const _hoisted_7 = { class: "card-content" }
const _hoisted_8 = { class: "title is-4" }
const _hoisted_9 = { class: "columns is-desktop" }
const _hoisted_10 = { class: "column is-one-third" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "title is-5" }, " Dirección ", -1)
const _hoisted_12 = { class: "subtitle is-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "block mb-6" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h5", { class: "title is-5" }, " Teléfono(s) ", -1)
const _hoisted_15 = { class: "subtitle is-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "block mb-6" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "divider is-vertical" }, null, -1)
const _hoisted_18 = { class: "column" }
const _hoisted_19 = { class: "is-flex is-flex-direction-row is-wrap is-justify-content-space-between is-align-content-space-between" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", { class: "title is-5" }, " Oficial de información ", -1)
const _hoisted_21 = {
  key: 0,
  class: "subtitle is-6"
}
const _hoisted_22 = { class: "mb-1" }
const _hoisted_23 = { class: "mb-1" }
const _hoisted_24 = { class: "mb-1" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 has-text-grey-darker" }, " No se ha asignado un administrador de la entidad ", -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "card mt-2" }
const _hoisted_29 = { class: "card-image" }
const _hoisted_30 = { class: "image is-1by1" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "divider is-vertical" }, null, -1)
const _hoisted_33 = { class: "column has-text-centered" }
const _hoisted_34 = { class: "is-flex is-flex-wrap-wrap is-align-items-center is-justify-content-center" }
const _hoisted_35 = { class: "notification new-color has-text-white-bis mb-5 is-flex is-flex-direction-column is-align-items-center custom-max-width" }
const _hoisted_36 = {
  key: 0,
  class: "title is-3"
}
const _hoisted_37 = {
  key: 1,
  class: "title is-2"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h6", { class: "subtitle is-6" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Promedio de puntuación"),
  /*#__PURE__*/_createElementVNode("p", null, "calidad de servicio de la entidad")
], -1)
const _hoisted_39 = { class: "notification new-color has-text-white-bis mb-5 is-flex is-flex-direction-column is-align-items-center custom-max-width" }
const _hoisted_40 = {
  key: 0,
  class: "title is-3"
}
const _hoisted_41 = {
  key: 1,
  class: "title is-2"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h6", { class: "subtitle is-6" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Porcentaje de certificación en el año actual")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "file-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "file-label" }, "Solicitud de información")
], -1)
const _hoisted_44 = { class: "ml-3 file-icon" }
const _hoisted_45 = { class: "card has-table has-mobile-sort-spaced" }
const _hoisted_46 = { class: "card-header" }
const _hoisted_47 = { class: "card-header-title" }
const _hoisted_48 = { class: "card-content" }

import { onMounted, ref} from "vue";
import {certificationComplianceService, entityService} from "@/services";
import SvgIcon from "@jamescoyle/vue-icon";
import {mdiFeatureSearch,mdiInformation} from "@mdi/js";
import AnnualChart from "@/components/common/charts/barChartEntityTransparency.vue";
import StarRating from "@/components/StartRating.vue"
import {CertificationCompliance} from "@/services/certification-compliance-service";
import {Entity} from "@/entities";
// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  props: {
  entityId: {
    type: Number,

    required: true,
  },
},
  setup(__props) {

const props = __props

/* eslint-disable @typescript-eslint/no-unused-vars,  @typescript-eslint/ban-types */
const defaultImageProfile = require("../assets/defaultProfilePicture.jpg");


const entity = ref<Entity | Record<string, unknown>>({});
const compliance = ref<CertificationCompliance[]>();
const currentYear = new Date().getFullYear();
const certificationTotal = ref("");

const getEntity = async () => {
  entity.value = await entityService.getEntity(props.entityId, true);
};

const getCompliance = async () => {
  try {
    compliance.value =
      await certificationComplianceService.getCertificationCompliance(
        currentYear,
        props.entityId
      );

    // GET TOTAL PERCENTAGE
    const totalMonths = compliance.value.length;
    let totalPercentage = 0;

    for (let item of compliance.value) {
      totalPercentage += item.percentage;
    }
    const total = totalPercentage / totalMonths;
    let temp = Math.round(total * 100);
    certificationTotal.value = temp.toString();
  } catch (error) {
    console.log(error);
  }
};

onMounted(async () => {
  await getEntity();
  await getCompliance();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h4", _hoisted_8, _toDisplayString(entity.value.name) + " | " + _toDisplayString(entity.value.acronym), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("h6", _hoisted_12, _toDisplayString(entity.value?.entity_profile?.address ||
                        "Sin dirección asignada"), 1),
                  _hoisted_13,
                  _hoisted_14,
                  _createElementVNode("h6", _hoisted_15, _toDisplayString(entity.value.entity_profile?.telephone ||
                        "Sin teléfono(s) asignados"), 1),
                  _hoisted_16
                ]),
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", null, [
                      _hoisted_20,
                      (entity.value.main_user != null)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_21, [
                            _createElementVNode("p", _hoisted_22, _toDisplayString(entity.value.main_user?.full_name || "Sin nombre asignado"), 1),
                            _createElementVNode("p", _hoisted_23, _toDisplayString(entity.value.main_user?.email || "Sin nombre asignado"), 1),
                            _createElementVNode("p", _hoisted_24, " Miembro de la entidad desde " + _toDisplayString(new Date(
                              entity.value.main_user?.created_at
                            ).toLocaleDateString("es-ES", {
                              weekday: "long",
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            }) || "Sin nombre asignado"), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("h6", _hoisted_25, _hoisted_27))
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("figure", _hoisted_30, [
                            _createElementVNode("img", {
                              src: 
                                entity.value.main_user?.profile_picture?.image?.url ||
                                  _unref(defaultImageProfile)
                              ,
                              alt: "profile picture"
                            }, null, 8, _hoisted_31)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      (entity.value.entity_score === 0)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_36, " Sin calificar "))
                        : (_openBlock(), _createElementBlock("h2", _hoisted_37, [
                            _createVNode(StarRating, {
                              rating: entity.value.entity_score,
                              "onUpdate:rating": _cache[0] || (_cache[0] = ($event: any) => ((entity.value.entity_score) = $event))
                            }, null, 8, ["rating"])
                          ])),
                      _hoisted_38
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      (certificationTotal.value === '')
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_40, " 0 % "))
                        : (_openBlock(), _createElementBlock("h2", _hoisted_41, _toDisplayString(certificationTotal.value) + " % ", 1)),
                      _hoisted_42
                    ]),
                    _createVNode(_component_router_link, {
                      to: { name: 'public-registration' },
                      class: "button is-flex custom-max-width new-color has-text-white-bis mt-2"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_43,
                        _createElementVNode("span", _hoisted_44, [
                          _createVNode(_unref(SvgIcon), {
                            path: _unref(mdiFeatureSearch),
                            type: "mdi"
                          }, null, 8, ["path"])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("header", _hoisted_46, [
              _createElementVNode("p", _hoisted_47, " Gráfico mensual del año " + _toDisplayString(_unref(currentYear)) + ", para la entidad " + _toDisplayString(entity.value.name), 1)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(AnnualChart, { compliance: compliance.value }, null, 8, ["compliance"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})